import axios from '@axios'
import requestSharedSettings from '@/helpers/settings-request'

// todo: fix it!
const widgetApiUrl = axios.defaults.baseURL.replace('api', 'widget')

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getEvent(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${widgetApiUrl}/${id}/data`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchSeats(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${widgetApiUrl}/seats/`, { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    makeOrder(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${widgetApiUrl}/order/`, queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    returnUrlData(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${widgetApiUrl}/orders/returnUrlData/`, queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    failUrlData(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${widgetApiUrl}/orders/failUrlData/`, queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getSimilar(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${widgetApiUrl}/${id}/similar`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    searchPromocode(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${widgetApiUrl}/promocodes/search`, { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    searchCommission(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${widgetApiUrl}/commission/search`, { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchEvents(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${widgetApiUrl}/fetchEvents`, queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    // Получаем настройки
    fetchSettings(ctx, queryParams = {}) {
      const fetcher = async () => {
        const response = await axios.post(`${widgetApiUrl}/fetchSettings`, queryParams)
        return response.data.data
      }

      if (queryParams.force) {
        return fetcher().then(settings => ({ data: { data: settings } }))
      }

      return requestSharedSettings('widget', fetcher).then(settings => ({ data: { data: settings } }))
    },
    fetchOrderLoyaltyTypes(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${widgetApiUrl}/orders/fetchOrderLoyaltyTypes`, queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    checkingPaymentStatusOrderWhenPayingByQRCode(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${widgetApiUrl}/checkingPaymentStatusOrderWhenPayingByQRCode`, queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchLoyaltySystemDataForUserEmail(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${widgetApiUrl}/fetchLoyaltySystemDataForUserEmail`, queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    checkOrderLimits(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${widgetApiUrl}/check-limits`, queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addLead(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${widgetApiUrl}/add-lead/`, queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
